export const SET_SUBTOPICS = 'subtopics/SET_SUBTOPICS';
export const SET_RATE = 'subtopics/SET_RATE';
export const SET_CHAPTERS = 'subtopics/SET_CHAPTERS';
